var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-zoomer',{ref:"vZoomer",attrs:{"zoomed":true,"pivot":"cursor","maxScale":7}},[_c('div',{staticClass:"map__data"},[_c('svg',{staticClass:"map_svg"})])])}
var staticRenderFns = []

export { render, staticRenderFns }